// icon:temperature-plus | Unicons https://iconscout.com/unicons | Iconscout
import * as React from "react";

function IconTemperatureMax(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M10.5 15.28V5.5a1 1 0 00-2 0v9.78a2 2 0 00-1 1.72 2 2 0 004 0 2 2 0 00-1-1.72zm9-12.78H19V2a1 1 0 00-2 0v.5h-.5a1 1 0 000 2h.5V5a1 1 0 002 0v-.5h.5a1 1 0 000-2zm-5.5 3a4.5 4.5 0 00-9 0V13a6 6 0 003.21 9.83 7 7 0 001.28.17A6 6 0 0014 13zm-2 14.61a4 4 0 01-6.42-2.2 4 4 0 011.1-3.76 1 1 0 00.3-.71V5.5a2.5 2.5 0 015 0v7.94a1 1 0 00.3.71 4 4 0 01-.28 6z" />
    </svg>
  );
}

export default IconTemperatureMax;
